import URL from '@/http/tbk/url'
import AjaxReq from '@/http/ajaxReq'
import JsonpReq from '@/http/jsonpReq'

export default {
  /**
   * 检查是否绑定淘宝账号
   * @param needAuthDialog 是否需要弹窗(此参数是前端自己定义的,用于在API拦截器中匹配url参数,判断是否需要弹窗)
   */
  bindTbCheck: async function(needAuthDialog) {
    let params = { _t: +new Date() }
    if (needAuthDialog === undefined || needAuthDialog === 1) {
      params.needAuthDialog = 1
    }
    let res = await AjaxReq({
      url: URL.BIND_TB_CHECK,
      method: 'get',
      data: params,
    })
    return res.data
  },
  /**
   * 绑定淘宝账号
   * @param {number} taobaoAuthcode  淘宝授权码
   */
  bindTb: async function(redirecUri, taobaoAuthcode) {
    let res = await AjaxReq({
      url: URL.BIND_TB,
      method: 'get',
      data: {
        redirecUri: redirecUri,
        code: taobaoAuthcode,
      },
    })
    return res.data
  },
  /**
   * 热门搜索
   */
  hotSearch: async function() {
    let res = await AjaxReq({
      url: URL.HOT_SEARCH,
      method: 'get',
      data: {},
    })
    return res.data
  },
  /**
   * 搜索
   * @param {number} kw 关键字
   */
  search: async function(kw, pageNo) {
    let res = await AjaxReq({
      url: URL.SEARCH,
      method: 'get',
      data: {
        kw: kw,
        pageNo: pageNo,
      },
    })
    return res.data
  },
  /**
   * 搜索关键字分类商品
   * @param {number} secKwId 关键字的分类ID
   */
  searchKwCateGoods: async function(secKwId) {
    let res = await AjaxReq({
      url: URL.SEARCH_KW_CATE_GOODS,
      method: 'get',
      data: {
        secKwId: secKwId,
      },
    })
    return res.data
  },
  /**
   * tab菜单
   * @param {number} kw 关键字
   */
  tabList: async function() {
    let res = await AjaxReq({
      url: URL.TAB_LIST,
      method: 'get',
      data: {},
    })
    return res.data
  },
  /**
   * tab菜单对应的轮播
   * @param {number} tabId 菜单ID
   */
  tabSlideList: async function(tabId) {
    let res = await AjaxReq({
      url: URL.TAB_SLIDE_LIST,
      method: 'get',
      data: {
        tabId: tabId,
      },
    })
    return res.data
  },
  /**
   * tab菜单对应的分类
   * @param {number} tabId 菜单ID
   */
  tabCateList: async function(tabId) {
    let res = await AjaxReq({
      url: URL.TAB_CATE_LIST,
      method: 'get',
      data: {
        tabId: tabId,
      },
    })
    return res.data
  },
  /**
   * tab菜单对应的完整分类
   * @param {number} tabId 菜单ID
   */
  tabCateAllList: async function(tabId) {
    let res = await AjaxReq({
      url: URL.TAB_CATE_ALL_LIST,
      method: 'get',
      data: {
        tabId: tabId,
      },
    })
    return res.data
  },
  /**
   * 三级分类列表
   * @param {number} cateId 二级分类ID
   */
  subCateList: async function(cateId) {
    let res = await AjaxReq({
      url: URL.SUB_CATE_LIST,
      method: 'get',
      data: {
        cateId: cateId,
      },
    })
    return res.data
  },
  /**
   * 好货优选
   * @param {number} pageNo 页码
   * @param {number} pageSize 每页长度
   */
  choiceGoodsList: async function(pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.CHOICE_GOODS_LIST,
      method: 'get',
      data: {
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
  /**
   * 为你推荐
   * @param {number} pageNo 页码
   * @param {number} pageSize 每页长度
   */
  recommendGoodsList: async function(pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.RECOMMEND_GOODS_LIST,
      method: 'get',
      data: {
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
  /**
   * tab菜单对应的商品列表
   * @param {number} tabId 菜单ID
   * @param {number} sort 1 销量正序  -1 销量倒叙  2 券后价正序  -2 券后价倒叙   空值 综合排序
   * @param {number} pageNo 页码
   * @param {number} pageSize 每页长度
   */
  tabGoodsList: async function(tabId, sort, pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.TAB_GOODS_LIST,
      method: 'get',
      data: {
        tabId: tabId,
        sort: sort || '',
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
  /**
   * 轮播图对应的商品列表
   * @param {number} slideAdId 轮播图广告ID
   * @param {number} sort 1 销量正序  -1 销量倒叙  2 券后价正序  -2 券后价倒叙   空值 综合排序
   * @param {number} pageNo 页码
   * @param {number} pageSize 每页长度
   */
  slideGoodsList: async function(slideAdId, sort, pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.SLIDE_GOODS_LIST,
      method: 'get',
      data: {
        slideAdId: slideAdId,
        sort: sort || '',
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
  /**
   * 分类对应的商品列表
   * @param {number} cateId 分类ID
   * @param {number} subCateId 子分类ID
   * @param {number} sort 1 销量正序  -1 销量倒叙  2 券后价正序  -2 券后价倒叙   空值 综合排序
   * @param {number} pageNo 页码
   * @param {number} pageSize 每页长度
   */
  cateGoodsList: async function(cateId, subCateId, sort, pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.CATE_GOODS_LIST,
      method: 'get',
      data: {
        cateId: cateId,
        subCateId: subCateId,
        sort: sort || '',
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
  /**
   * 商品详情
   * @param {number} goodsId 商品ID
   */
  goodsDetail: async function(goodsId) {
    let res = await AjaxReq({
      url: URL.GOODS_DETAIL,
      method: 'get',
      data: {
        goodsId: goodsId,
      },
    })
    return res.data
  },
  /*
   * 淘宝商品详情
   * @param {number} goodsId 商品ID
   */
  tbGoodsDetail: async function(goodsId) {
    let res = await JsonpReq({
      url: URL.TB_GOODS_DETAIL,
      option: {
        name: `jsonp_${new Date().getTime()}`,
      },
      data: {
        jsv: '2.4.8',
        appKey: '12574478',
        api: 'mtop.taobao.detail.getdetail',
        v: '6.0',
        ttid: '2017@taobao_h5_6.6.0',
        AntiCreep: 'true',
        dataType: 'jsonp',
        type: 'jsonp',
        data: JSON.stringify({ itemNumId: goodsId }),
      },
    })
    return res.data
  },
  /**
   * 淘宝商品详情
   * @param {number} goodsId 商品ID
   */
  tbGoodsDesc: async function(goodsId) {
    let res = await JsonpReq({
      url: URL.TB_GOODS_DESC,
      option: {
        name: `jsonp_${new Date().getTime()}`,
      },
      data: {
        jsv: '2.5.1',
        appKey: '12574478',
        api: 'mtop.taobao.detail.getdesc',
        v: '6.0',
        isSec: '0',
        ecode: '0',
        AntiFlood: 'true',
        AntiCreep: 'true',
        H5Request: 'true',
        type: 'jsonp',
        dataType: 'jsonp',
        data: JSON.stringify({
          ttid: '2014_0_23444710@baichuan_iphone_3.1.1.200',
          ybhpss: 'dHRpZD0yMDE0XzBfMjM0NDQ3MTAlNDBiYWljaHVhbl9pcGhvbmVfMy4xLjEuMjAw',
          u_channel: '1-23444710',
          id: goodsId,
          spm: 'a220l.11009277.recommend.3',
          scm: '1007.18975.103645.0',
          umpChannel: '1-23444710',
          isv_code: 'com.jf.PeanutAdiaryHotVersion',
          pvid: 'b8db7629-b333-4f97-abd9-f58bba6a126f',
          utparam: JSON.stringify({
            ranger_buckets_native: '17638_17639_15948_11514_6595_13440_11609_11608_12894_12893_17347_11513',
            x_object_type: 'item',
            mtx_ab: 1,
            mtx_sab: 0,
            scm: '1007.18975.103645.0',
            x_object_id: goodsId,
          }),
          type: '0',
        }),
      },
    })
    return res.data
  },
  /**
   * 获取淘口令
   * @param {string} title 商品名称
   * @param {string} couponClickUrl 淘宝优惠券链接
   * @param {string} buyUrl 淘宝购买链接
   */
  getTkl: async function(title, couponClickUrl, buyUrl) {
    let res = await AjaxReq({
      url: URL.GET_TB_TKL,
      method: 'get',
      data: {
        title: title,
        couponClickUrl: couponClickUrl,
        buyUrl: buyUrl,
      },
    })
    return res.data
  },
  /**
   * 保存商品详情(搜索之后点击分享)
   * @param {string} goodsDetailJson 商品详情的json字符串
   */
  saveSearchGoodsDetail: async function(goodsDetailJson) {
    let res = await AjaxReq({
      url: URL.SAVE_SEARCH_GOODS_DETAIL,
      method: 'get',
      data: {
        goodsDetail: goodsDetailJson,
      },
    })
    return res.data
  },
  /**
   * 商品详情(点击搜索的商品分享后的链接)
   * @param {string} goodsId 商品ID
   */
  querySearchGoodsDetail: async function(goodsId) {
    let res = await AjaxReq({
      url: URL.QUERY_SEARCH_GOODS_DETAIL,
      method: 'get',
      data: {
        goodsId: goodsId,
      },
    })
    return res.data
  },
  /**
   * 收藏商品
   * @param {number} goodsId 商品ID
   */
  markProduct: async function(goodsId) {
    let res = await AjaxReq({
      url: URL.MARK_PRODUCT,
      method: 'get',
      data: {
        goodsId: goodsId,
      },
    })
    return res.data
  },
  /**
   * 取消收藏商品
   * @param {number} goodsId 商品ID
   */
  unmarkProduct: async function(goodsId) {
    let res = await AjaxReq({
      url: URL.UNMARK_PRODUCT,
      method: 'get',
      data: {
        goodsId: goodsId,
      },
    })
    return res.data
  },
  /**
   * 批量移除收藏的商品
   * @param {number} ids 多个商品ID,中间以|分割
   */
  unmarkProductByIds: async function(ids) {
    let res = await AjaxReq({
      url: URL.UNMARK_PRODUCT_BY_IDS,
      method: 'get',
      data: {
        ids: ids,
      },
    })
    return res.data
  },
  /**
   * 收藏的商品列表
   * @param {number} goodsId 商品ID
   */
  markedProductList: async function(pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.MARKED_PRODUCT_LIST,
      method: 'get',
      data: {
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },  
  /**
   * 金豆合计
   */
  beanBalance: async function() {
    let res = await AjaxReq({
      url: URL.BEAN_BALANCE,
      method: 'get',
      data: {},
    })
    return res.data
  },
  /**
   * 金豆列表
   * @param {number} type  0:未结算  1:已结算
   */
  beanList: async function(type, pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.BEAN_LIST,
      method: 'get',
      data: {
        type: type,
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
  /**
   * 已结算收益合计
   */
  settledProfitBalance: async function() {
    let res = await AjaxReq({
      url: URL.SETTLED_PROFIT_BALANCE,
      method: 'get',
      data: {},
    })
    return res.data
  },
  /**
   * 已结算收益列表
   * @param {number} type  0:全部  1:今日  2:本月  3:上月
   */
  settledProfitList: async function(type, pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.SETTLED_PROFIT_LIST,
      method: 'get',
      data: {
        type: type,
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
  /**
   * 待结算收益合计
   */
  unsettledProfitBalance: async function() {
    let res = await AjaxReq({
      url: URL.UNSETTLED_PROFIT_BALANCE,
      method: 'get',
      data: {},
    })
    return res.data
  },
  /**
   * 待结算收益列表
   * @param {number} type  0:全部  1:今日  2:本月  3:上月
   */
  unsettledProfitList: async function(type, pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.UNSETTLED_PROFIT_LIST,
      method: 'get',
      data: {
        type: type,
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
  /**
   * 我的订单
   * @param {number} state  0:全部 12:待结算 3:已结算 13:失效
   */
  orderList: async function(state, pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.ORDER_LIST,
      method: 'get',
      data: {
        state: state,
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
  /**
   * 团队订单
   * @param {number} state  0:全部 12:待结算 3:已结算 13:失效
   */
  teamOrderList: async function(state, pageNo, pageSize) {
    let res = await AjaxReq({
      url: URL.TEAM_ORDER_LIST,
      method: 'get',
      data: {
        state: state,
        pageNo: pageNo,
        pageSize: pageSize || 20,
      },
    })
    return res.data
  },
  // 查询未绑定订单
  queryUnbindTbOrder: async function(orderNo) {
    let res = await AjaxReq({
      url: URL.QUERY_UNBIND_TB_ORDER,
      method: 'get',
      data: {
        orderNo: orderNo,
      },
    })
    return res.data
  },
  // 绑定订单
  bindTbOrder: async function(orderNo) {
    let res = await AjaxReq({
      url: URL.BIND_TB_ORDER,
      method: 'get',
      data: {
        orderNo: orderNo,
      },
    })
    return res.data
  },
}
